import classnames from 'classnames';
import { makeStyles } from '~/lib/bn-material-ui';
import React from 'react';
import { FileDocumentAlert, FileDocumentArrowRight, FileDocumentCheck } from '~/common/mdi-icons';
import { FileDocumentImported } from '~/utility/BinSentry-ui-utility';

const useStyles = makeStyles((theme) => {
  return {
    integrationIcon: {
      overflow: 'visible',
      color: theme.palette.green[20],
    },
    error: {
      color: theme.palette.red[20],
    },
    'not-synced': {
      color: theme.palette.gray[60],
    },
    loading: {
      opacity: 0.5,
    },
    'size-small': {},
    'size-normal': {},
    fixMuiIcon: {
      display: 'inline-block',
      marginLeft: '0.3rem',
      '& $size-small': {
        fontSize: '1rem',
      },
      '& $size-normal': {
        fontSize: '1.5rem',
      },
    },
  };
});

export default function OrderIntegrationIcon({ loading, state, size }) {
  const styles = useStyles();
  const classes = [{ [styles.loading]: loading }, styles[state], styles.integrationIcon];
  const muiIconClass = size === 'small' ? styles['size-small'] : styles['size-normal'];
  switch (state) {
  case 'error':
    return <FileDocumentAlert size={1} className={classnames(...classes)}/>;
  case 'loading':
  case 'not-synced':
    return <FileDocumentArrowRight size={1} className={classnames(...classes)}/>;
  case 'success':
    return <FileDocumentCheck size={1} className={classnames(...classes)}/>;
  case 'success-pull':
    return <span className={styles.fixMuiIcon}><FileDocumentImported className={classnames(...classes, muiIconClass)}/></span>;
  default:
    throw new Error(`Invalid state: ${state}`);
  }
}
